import { useCallback, useRef, useState } from 'react';
import { attributesToProps } from 'html-react-parser';
import { MessageCircle, X } from 'lucide-react';
import { ChatPanel } from './ChatPanel';
import { useLeahConversation } from '../hooks/useLeahConversation';
import { useEscapeDismiss } from '../hooks/useDomEffects';

export const LeahChat = ({ node }) => {
  const [open, setOpen] = useState(false);
  const launcher = useRef(null);
  const conversation = useLeahConversation();
  const props = attributesToProps(node.attribs);
  const button = node.children.find(child => child.name === 'button');
  const buttonProps = attributesToProps(button.attribs);
  const close = useCallback(() => { setOpen(false); launcher.current?.focus(); }, []);
  useEscapeDismiss(open, close);
  return <div {...props}>
    {open && <ChatPanel {...conversation} close={close} />}
    <button {...buttonProps} ref={launcher} aria-expanded={open} aria-controls="leah-chat-panel" onClick={() => open ? close() : setOpen(true)}>
      {open ? <X size={16} aria-hidden="true" /> : <MessageCircle size={16} aria-hidden="true" />}
      <span className="text-[13px] font-semibold" data-testid="leah-launcher-text">{open ? 'Close chat' : 'Chat with Leah'}</span>
    </button>
  </div>;
};